const inicialState = {
  listaSolicitacoes: [],
  totalSolicitado: 0
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/solicitacao.state.js